import { render, staticRenderFns } from "./damageResultUptec.pug?vue&type=template&id=129e748e&lang=pug&"
import script from "./damageResultUptec.js?vue&type=script&lang=js&"
export * from "./damageResultUptec.js?vue&type=script&lang=js&"
import style0 from "./damageResultUptec.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('129e748e')) {
      api.createRecord('129e748e', component.options)
    } else {
      api.reload('129e748e', component.options)
    }
    module.hot.accept("./damageResultUptec.pug?vue&type=template&id=129e748e&lang=pug&", function () {
      api.rerender('129e748e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damageResultUptec/index.vue"
export default component.exports